/** 数字 → 紧凑表示：<1000 原数；<1e6 一位小数 K；≥1e6 一位小数 M。整数 K/M 去掉 .0。 */
export function formatToken(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return '0';
  if (n < 1000) return String(Math.round(n));
  if (n < 1_000_000) {
    const v = n / 1000;
    const fixed = v.toFixed(1);
    return (fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed) + 'K';
  }
  const v = n / 1_000_000;
  const fixed = v.toFixed(1);
  return (fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed) + 'M';
}
